import { useState, useEffect } from "react";
import { X } from "lucide-react";
import QuickCallbackForm from "./QuickCallbackForm";

/** Desktop-only bottom bar with a 2-field callback form, shown after scrolling. */
const StickyQuoteBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("obc_callback_bar_closed") === "1");

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => { sessionStorage.setItem("obc_callback_bar_closed", "1"); setDismissed(true); };

  if (dismissed || !visible) return null;

  return (
    <div className="hidden md:block fixed bottom-0 left-0 right-0 z-40 bg-primary text-primary-foreground shadow-lg border-t border-primary/80">
      <div className="container mx-auto px-4 py-3 flex items-center justify-center gap-3">
        <span className="font-semibold text-sm whitespace-nowrap">Request a Roof Inspection →</span>
        <QuickCallbackForm source="sticky-callback-bar" compact onDone={close} />
        <button type="button" aria-label="Close" onClick={close} className="ml-2 opacity-60 hover:opacity-100">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default StickyQuoteBar;
